import { bindPopoverListeners } from "./notifications-listener";
import { createNotificationsController } from "./notifications-handler";
import { phpAuthUser } from "../core/php-data-access";
import { notificationsForm } from "./notifications-form";

export function initNotifications(): void {
    try {
        if (!phpAuthUser()) return;
        const triggerEl = notificationsForm.getTrigger(document);
        if (!(triggerEl instanceof HTMLElement)) return;

        const popoverEl = notificationsForm.getPopover(triggerEl);
        const loadingEl = notificationsForm.getLoading(triggerEl);
        const listEl = notificationsForm.getList(triggerEl);
        const emptyEl = notificationsForm.getEmpty(triggerEl);
        const badgeEl = notificationsForm.getBadge(document);

        if (!(popoverEl instanceof HTMLElement)) return;
        if (!(loadingEl instanceof HTMLElement)) return;
        if (!(listEl instanceof HTMLElement)) return;
        if (!(emptyEl instanceof HTMLElement)) return;

        const overlayEl = notificationsForm.getOverlay(document);

        const controller = createNotificationsController({
            triggerEl,
            popoverEl,
            loadingEl,
            listEl,
            emptyEl,
            badgeEl,
            overlayEl,
        });

        if (overlayEl instanceof HTMLElement) {
            overlayEl.addEventListener("click", () => controller.close());
        }

        void controller.updateUnreadBadge();

        bindPopoverListeners({
            triggerEl,
            popoverEl,
            onToggle: controller.toggle,
            onClose: controller.close,
        });
    } catch (_error) {
        // Silent fail (optional UI)
    }
}
